import gql from 'graphql-tag';

export default gql`
query getItemName($id: Int!) {
  folders_by_pk(folder_id: $id) {
    name
  }
}
`;
